import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button, Input } from '@/kaya';
import Icons from '@/icons';
import { iconConstants, routesConstants } from '@/constants';
import { generalHelpers } from '@/helpers';
import { userActions } from '@/actions';
import logo from '@/assets/upperLogin-image.png';

import styles from './ResetPassword.module.scss';

const ResetPassword = () => {
  const [searchParams, setSeararams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token') || '';
  const [password, setPassword] = React.useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [err, setErr] = React.useState<{ [key: string]: string }>({
    password: '',
    confirmPassword: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleEyeClick = () => {
    setShowPassword(!showPassword);
  };

  const handleConfirmEyeClick = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleResetPassword = async () => {
    const error = {
      password: generalHelpers.validatePassword(password),
      confirmPassword: generalHelpers.validateConfirmPassword(password, confirmPassword),
    };
    if (!generalHelpers.isEmptyErrors(error)) {
      setErr(error);
      return;
    }
    setIsLoading(true);
    // write api call here
    const data = await userActions.resetPasswordAction({
      payload: { emailToken: token, password, rePassword: confirmPassword },
    });
    if (data.success) {
      navigate(routesConstants.ROUTES.LOGIN);
    }
    setIsLoading(false);
  };

  return (
    <div className={styles.ResetPassword}>
      <div className={styles.logo}>
        <img src={logo} alt="logo" className={styles.logoImg} />
      </div>
      <div className={styles.box}>
        <p className={styles.desc}>Reset Password</p>
        <p className={styles.desc2}>Create a new secure password</p>

        <div className={styles.box1}>
          <Input
            type={showPassword ? 'string' : 'password'}
            placeholder="New Password"
            className={styles.input}
            width="100%"
            value={password}
            onChange={(e) => {
              setPassword(e),
                setErr({
                  ...err,
                  password: '',
                });
            }}
            errors={err}
            id="password"
            onSuffixIconClick={handleEyeClick}
            suffixIcon={
              <Icons type={showPassword ? iconConstants.ICONS.EYEOFF : iconConstants.ICONS.EYEON} />
            }
          />
          <Input
            type={showConfirmPassword ? 'string' : 'password'}
            placeholder="Confirm Password"
            className={styles.input1}
            width="100%"
            onChange={(e) => {
              setConfirmPassword(e),
                setErr({
                  ...err,
                  confirmPassword: '',
                });
            }}
            errors={err}
            id="confirmPassword"
            onEnterClick={handleResetPassword}
            onSuffixIconClick={handleConfirmEyeClick}
            suffixIcon={
              <Icons
                type={showConfirmPassword ? iconConstants.ICONS.EYEOFF : iconConstants.ICONS.EYEON}
              />
            }
          />
          <Button
            className={styles.btn}
            onClick={handleResetPassword}
            type="Primary"
            isLoading={isLoading}
          >
            Reset Password
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
